import { render } from "./ProductTradeConditionChart.vue?vue&type=template&id=81aafc8a&ts=true"
import script from "./ProductTradeConditionChart.vue?vue&type=script&lang=ts"
export * from "./ProductTradeConditionChart.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__